import { cn } from "components/lib/utils";
import { CaseExport } from "generated/graphql";
import CaseExportItem from "routes/lenses/lens/case/CaseExportItem";

export default function SBRExportsCenter({ caseId, exports }: { caseId: number; exports: CaseExport[] }) {
  return (
    <div className={cn("overflow-auto w-full p-2", exports.length ? ["min-h-[200px]"] : ["min-h-[100px]"])}>
      {exports.length ? (
        exports.map((exp) => (
          <CaseExportItem
            key={exp.id}
            exp={exp}
            caseId={caseId}
            isLastItem={exports.indexOf(exp) === exports.length - 1}
          />
        ))
      ) : (
        <div className="flex h-full items-center justify-center">
          <p className="text-sm">No Exports Yet</p>
        </div>
      )}
    </div>
  );
}
